import { useRouter } from 'next/router';
import shareLinks from '../__helpers__/shareLinks';
import { ISocialLink } from '@components/Homepage/Header/interfaces';
import { usePostContext } from '@components/Post/PostContext';
import { MAIN_URL } from '@src/commons/constants';

const useShareLinks = (): ISocialLink[] => {
  const { post } = usePostContext();
  const { asPath } = useRouter();
  const url = `${MAIN_URL}${asPath}`;

  return shareLinks.map((handler) =>
    handler(post.title ?? '', url, post.mainPhoto?.asset?.url ?? '')
  );
};

export default useShareLinks;
